import { createContext, useContext, Dispatch } from 'react';

import { initialState } from './reducer';
import { ActionType, LegalEntityFormActions, StateType } from './types';

type StoreType = {
  state: StateType;
  dispatch: Dispatch<ActionType>;
  actions: LegalEntityFormActions;
};

export const LegalEntityFormDispatch = createContext<StoreType>({
  state: initialState,
  dispatch: () => {},
  actions: {
    setLegalEntity: () => {},
    setLoadingLegalEntity: () => {},
  },
});

export const useLegalEntityFormContext = (): StoreType => useContext(LegalEntityFormDispatch);
